export default function () {
  var directiveDefinitionObject = {
    restrict: "A",
    compile: function compile(tElement, tAttrs, transclude) {
      return {
        pre: function preLink(scope, iElement, iAttrs, controller) {
          scope[iAttrs.ngScopeElement] = iElement;
        }
      };
    }
  };

  return directiveDefinitionObject;
}



// WEBPACK FOOTER //
// ./src/ui/app/directives/ngScopeElement.js